import React from "react";
import bannerImg from "../../assets/images/saless.png";
import "../../styles/SalesFunnel.css";

import { Link } from "react-router-dom";

function SFbanner() {
  return (
    <div>
      <section className="webbanner">
        <div className="webbanner-content">
          <h1>Sales Funnel Optimization: Boost Conversions and Drive Growth</h1>
          <p>
            In today’s fairly aggressive digital marketplace, corporations must
            prioritize <b>sales funnel optimization</b> to maximize ROI and convert
            prospects into dependable customers. A strategically designed funnel
            no longer simplest draws exquisite site visitors, but also nurtures
            leads across every stage of the customer journey.
          </p>
            <div className="webbanner-cta">
            <a href="./Contact" className="webbanner-btn primary">
              Get Free Consultation →
            </a>
          </div>
        </div>
        <div className="webbanner-image">
          <img src={bannerImg} alt="Web Development Solutions" />
        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>Sales Funnel Optimization</span>
      </div>
    </div>
  );
}

export default SFbanner;
